module.exports = __webpack_public_path__ + "img/Logo.9cc19ff9.png";